import Ace from 'ace-builds';
import modeHTML from 'ace-builds/src-noconflict/mode-html';
import workerHTML from 'ace-builds/src-noconflict/worker-html';
import themeChrome from 'ace-builds/src-noconflict/theme-chrome';

// HTML mode
Ace.config.setModuleUrl('ace/mode/html', modeHTML);
Ace.config.setModuleUrl('ace/mode/html_worker', workerHTML);

// Chrome theme
Ace.config.setModuleUrl('ace/theme/chrome', themeChrome);

export default Ace;
